<template>
  <div>
    <div>
      <div class="col-lg-12 m-t-sm">
        <div class="col-lg-4 col-md-6">
          <table class="table table-hover">
              <thead class="header-table">
                <tr>
                  <th id="filters">
                    Categories
                    <input type="text" class="col-lg-6 pull-right pretty-input" placeholder="Search" v-model="categoryFilter" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="cat in filteredRows" :key="cat.id">
                  <td>
                    <e-txt
                        type="editable"
                        :text="cat.name"
                        @input="saveCategory($event, cat.id)"
                        close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
              </tbody>
          </table>
        </div>
        <div class="col-lg-4 col-md-4">
          <table class="table table-hover">
            <thead class="header-table">
            <tr>
              <th style="padding-bottom: 1.5em;">Add Category</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <input type="text" class="form-control" placeholder="Name" v-model="newCatName">
                <button class="btn btn-primary btn-sm m-t-xs" :disabled="!newCatName" @click="saveCategory()">Save</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import EditText from '../../../../Helpers/Form/EditText'
import axios from 'axios'
export default {
  data () {
    return {
      categoryFilter: '',
      newCatName: '',
      categories: []
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    }),
    filteredRows () {
      return this.categories.filter(row => row.name.toLowerCase().includes(this.categoryFilter.toLowerCase()))
    }
  },
  components: {
    eTxt: EditText
  },
  mounted () {
    this.getCategories()
  },
  methods: {
    async getCategories () {
      try {
        let r = await axios.get(`/pbn/categories/`)
        this.categories = r.data
      } catch (e) {
        this.$toastr.error(e, 'Error loading the categories')
      }
    },
    async saveCategory (newName = null, id = null) {
      let data = {}
      newName == null ? data['name'] = this.newCatName : data['name'] = newName
      try {
        if (id) {
          if (!newName.length) {
            this.$toastr.error('Category name is missing')
            return
          }
          axios.patch(`/pbn/categories/${id}`, data)
          this.$toastr.success('Category name updated')
        } else {
          axios.post('/pbn/categories', data)
          this.$toastr.success('Category created')
        }
      } catch (e) {
        this.$toastr.error('Unable to save the category')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Data/Tabs/Categories.vue